module.exports = __webpack_public_path__ + "img/eye.3f390013.svg";